import { builderFetch } from '../../utilities';
const { isDefined } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.title;

/**
 * Sets a new recipe title (post_title)
 *
 * @param {String} newTitle The recipe title
 * @return {Promise} The apiFetch promise
 */
const setRecipeTitle = ( newTitle ) => {
	// Save the recipe title
	return builderFetch( {
		endpoint: 'change_post_title',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			post_title: newTitle
		},
		snackbar: {
			loading: strings.updating,
			success: strings.updated,
		}
	} );
}

export default setRecipeTitle;
